import React from "react";

import SwapScrollview from "./swap-scrollview";
import TextMessage from "../text-message/text-message";
import { buttonClickHandler } from "../buttons/button-click-handler";
import ButtonIcon from "./button-icon";
// import { Link } from "react-router-dom";
// import { Swiper, SwiperSlide } from "swiper/react";
// import "swiper/swiper.min.css";
// import "swiper/css/pagination";

// const DUMMY_CARDS = [
//   {
//     title: "Luxury Suite",
//     description:
//       "Experience the ultimate in comfort and style with our Luxury Suite. This spacious room features a king-sized bed, a private balcony with stunning views, and a luxurious bathroom with a jacuzzi.",
//     image:
//       "https://dq5r178u4t83b.cloudfront.net/wp-content/uploads/sites/15/2021/06/23115256/Luxury-Room-twin-sofitel-dubai-the-palm-2-585x390.jpg",
//     buttons: [
//       {
//         title: "Book Now",
//         id: "book_luxury_suite",
//         payload: {
//           roomType: "Luxury Suite",
//           action: "book",
//         },
//       },
//       {
//         title: "View Details",
//         id: "view_details_luxury_suite",
//         payload: {
//           roomType: "Luxury Suite",
//           action: "view_details",
//         },
//       },
//       {
//         title: "Add to Wishlist",
//         id: "add_to_wishlist_luxury_suite",
//         payload: {
//           roomType: "Luxury Suite",
//           action: "add_to_wishlist",
//         },
//       },
//     ],
//   },
//   {
//     title: "Family Room",
//     description:
//       "Perfect for families, our Family Room offers two queen-sized beds, a cozy seating area, and a convenient kitchenette. Enjoy a comfortable stay with enough space for everyone.",
//     image:
//       "https://www.bhg.com/thmb/tMC_sOM2oF-NhItXBZOChTXSFUs=/4000x0/filters:no_upscale():strip_icc()/Open-concept-living-room-TWP0380-CV1hghhEaBBAkX_uv8K9cw-3313dfd39e2b42f5b37f43b8dfa14e08.jpg",
//     buttons: [
//       {
//         title: "Book Now",
//         id: "book_family_room",
//         payload: {
//           roomType: "Family Room",
//           action: "book",
//         },
//       },
//       {
//         title: "View Details",
//         id: "view_details_family_room",
//         payload: {
//           roomType: "Family Room",
//           action: "view_details",
//         },
//       },
//       {
//         title: "Add to Wishlist",
//         id: "add_to_wishlist_family_room",
//         payload: {
//           roomType: "Family Room",
//           action: "add_to_wishlist",
//         },
//       },
//     ],
//   },
//   {
//     title: "Business Suite",
//     description:
//       "Our Business Suite is designed for the modern traveler. It features a spacious work desk, high-speed internet access, and a comfortable seating area to help you stay productive during your stay.",
//     image:
//       "https://www.hotelmetropolitan.com/blog/wp-content/uploads/2012/03/Hotel-Metropolitan_business-suite_room.jpg",
//     buttons: [
//       {
//         title: "Book Now",
//         id: "book_business_suite",
//         payload: {
//           roomType: "Business Suite",
//           action: "book",
//         },
//       },
//       {
//         title: "View Details",
//         id: "view_details_business_suite",
//         payload: {
//           roomType: "Business Suite",
//           action: "view_details",
//         },
//       },
//       {
//         title: "Add to Wishlist",
//         id: "add_to_wishlist_business_suite",
//         payload: {
//           roomType: "Business Suite",
//           action: "add_to_wishlist",
//         },
//       },
//     ],
//   },
// ];

export default function SwapCardList(props) {
  const { message, onInvokeAction } = props;
  const { cards, displayText, fallbackConfig } = message;

  const substrText = (string) => {
    let cpText = string;
    const length = string.length;
    if (length >= 100) {
      return `${cpText.substr(0, 100)} ..`;
    }
    return cpText;
  };

  const handleOptionClick = async (option) => {
    console.log('handleOptionClick', option)
    await buttonClickHandler(onInvokeAction)(option.payload, option);
  };

  // const viewportSlidesPerView = useMemo(
  //   () => (cards?.length === 1 ? 1 : 2),
  //   [cards]
  // );

  const hasCards = Array.isArray(cards) && cards.length > 0;
  const fallbackButtons = (fallbackConfig?.fallbackActions || []).map((a) => ({
    title: a?.title,
    payload: a?.payload,
    actionType: a?.actionType,
    icon: a?.icon,
    slot: a?.slot,
    id: a?.id,
  }));

  return (
    <div className="flex flex-col w-full bg-inherit">
      {displayText &&
      <div className="mr-3 relative">
      <TextMessage message={displayText} senderType={props.senderType} />
    </div>
      }

      {/* Cards viewer */}
      {hasCards ? (
        <div className="my-4 p-1 box-border">
          <SwapScrollview data={cards} handleItemClick={handleOptionClick} />
        </div>
      ) : (
        <div className="my-4 p-1 box-border">Contents not found</div>
      )}

      {fallbackConfig?.fallbackDescription && (
        <div className="mr-3 relative">
          <TextMessage message={fallbackConfig.fallbackDescription} senderType={props.senderType} />
        </div>
      )}

      {fallbackButtons.length > 0 && (
        <div className="flex flex-col gap-2 p-1 w-1/4">
          {fallbackButtons.map((rawData, index) => (
            <button
              key={index}
              onClick={() => {
                handleOptionClick(rawData)
              }}
              className="
              relative py-0.5 text-sm font-medium text-center text-clip block leading-9 rounded-md bg-gray-100 text-gray-600 tracking-wide 
              hover:bg-indigo-600 hover:text-white hover:shadow-md transition-all duration-300"
            >
              <ButtonIcon icon={rawData?.icon} alt={rawData?.title} />
              {rawData.title}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
